import LC from "../assets/images/LC.jpg"
import DICP from "../assets/images/Design Innovation Centre - Summer Internship.png"
const Ex = [
    {
        imgUrl: LC, 
        title: "Leetcode",
        description: "Leetcode is a online coding platform for practising the concepts of Data Structures and Algorithms. Have Around 370 questions which constitutes of topics such as Array, Queue, Stack, Linked Lists, Trees, Graphs, Dynamic Programming, etc", 
        skills: "C++ Programming Language",
        weblink: "https://leetcode.com/RDBcode/",
      },
      {
        imgUrl: DICP, 
        title: "Summer Internship at DIC",
        description: "Desingned a poster of Summer Internship for a Research and Information Technology Organisation, name Design Innovation Centre(DIC).", 
        skills: "Canva (Designing)",
        weblink: "https://drive.google.com/file/d/1JfEym92sujqnkk-8GoD1h6TRf8PzgjnU/view?usp=sharing",
      },
];

export default Ex